import { AuthenticationService } from '@services/authentication.service';

export function appInitializer(authenticationService: AuthenticationService) {
  return () => new Promise<void>((resolve, reject) => {
    authenticationService.refresh()
    .subscribe({
      next: token => {
        if (token && token['requirePasswordChange']) {
          authenticationService.requirePasswordChange();
        }
        resolve();
      },
      error: err => {
        authenticationService.logout();
        resolve(err);
      }
    });
  });
}
